// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_ADMIN = '/admin';
const ROOTS_AUTH = '/auth';
const ROOTS_BASE = '';

// ----------------------------------------------------------------------

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  progress: path(ROOTS_DASHBOARD, '/progress'),
  focus: path(ROOTS_DASHBOARD, '/focus'),
  profile: path(ROOTS_DASHBOARD, '/profile'),
  decks: {
    root: path(ROOTS_DASHBOARD, '/decks'),
    import: path(ROOTS_DASHBOARD, '/decks/import'),
    detail: (id) => path(ROOTS_DASHBOARD, `/decks/${id}`),
    review: (id) => path(ROOTS_DASHBOARD, `/decks/${id}/review`),
    unlock: (id) => path(ROOTS_DASHBOARD, `/decks/${id}/unlock`),
    join: (code) => path(ROOTS_DASHBOARD, `/decks/join/${code}`),
  },
  account: {
    root: path(ROOTS_DASHBOARD, '/account'),
    me: path(ROOTS_DASHBOARD, '/account/me'),
  },
};

export const PATH_ADMIN = {
  root: ROOTS_ADMIN,
  users: path(ROOTS_ADMIN, '/users'),
  user: (uid) => path(ROOTS_ADMIN, `/users/${uid}`),
  audit: path(ROOTS_ADMIN, '/audit'),
};

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  resetPassword: path(ROOTS_AUTH, '/reset-password')
};

export const PATH_PAGE = {
  root: ROOTS_BASE,
  landing: process.env.REACT_APP_HOST_LANDING,
  terms: `${process.env.REACT_APP_HOST_LANDING}/terms`,
  privacy: `${process.env.REACT_APP_HOST_LANDING}/privacy`,
  subscription: {
    success: '/subscriptions/success',
    cancel: '/subscriptions/cancel',
  }
}